import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon, BuildingOfficeIcon, UserGroupIcon, AcademicCapIcon,
  ShieldCheckIcon, XMarkIcon, ChartBarIcon, UserCircleIcon,
  CreditCardIcon, ServerIcon, BanknotesIcon, InboxStackIcon,
} from '@heroicons/react/24/outline';

const NAV = [
  { label:'OVERVIEW', items:[
    { name:'Dashboard',       href:'/super/dashboard',         icon:HomeIcon },
  ]},
  { label:'BILLING & PLANS', items:[
    { name:'Subscriptions',   href:'/super/subscriptions',     icon:CreditCardIcon },
    { name:'Services',        href:'/super/services',          icon:ServerIcon },
    { name:'Billing',         href:'/super/billing',           icon:BanknotesIcon },
  ]},
  { label:'MANAGEMENT', items:[
    { name:'Schools',         href:'/super/schools',           icon:BuildingOfficeIcon },
    { name:'Admins',          href:'/super/admins',            icon:ShieldCheckIcon },
    { name:'Owners',          href:'/super/owners',            icon:UserCircleIcon },
    { name:'Branch Requests', href:'/super/branch-requests',   icon:InboxStackIcon, badge:true },
    { name:'Teachers',        href:'/super/teachers',          icon:AcademicCapIcon },
    { name:'Students',        href:'/super/students',          icon:UserGroupIcon },
  ]},
];

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
  .ss * { box-sizing:border-box; }
  .ss { width:230px; min-width:230px; height:100vh; background:#0a0c1b; display:flex; flex-direction:column; overflow-x:hidden; font-family:'Sora',sans-serif; flex-shrink:0; z-index:50; }
  .ss-brand { padding:20px 18px 16px; border-bottom:1px solid rgba(255,255,255,.06); }
  .ss-logo  { display:flex; align-items:center; gap:10px; }
  .ss-logo-icon { width:38px; height:38px; background:linear-gradient(135deg,#f59e0b,#ef4444); border-radius:11px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .ss-logo-icon svg { width:20px; height:20px; stroke:white; stroke-width:2; }
  .ss-logo-text { font-size:.9rem; font-weight:700; color:white; line-height:1.2; }
  .ss-logo-sub  { font-size:.6rem; color:rgba(255,255,255,.35); text-transform:uppercase; letter-spacing:.1em; margin-top:2px; }
  .ss-nav { flex:1; padding:14px 10px; overflow-y:auto; overflow-x:hidden; scrollbar-width:none; }
  .ss-nav::-webkit-scrollbar { display:none; }
  .ss-group-label { font-size:.6rem; font-weight:700; color:rgba(255,255,255,.25); text-transform:uppercase; letter-spacing:.1em; padding:0 10px; margin:14px 0 6px; }
  .ss-item { display:flex; align-items:center; gap:10px; padding:9px 12px; border-radius:10px; color:rgba(255,255,255,.45); font-size:.8rem; font-weight:500; text-decoration:none; transition:all .15s; margin-bottom:2px; }
  .ss-item-text { flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .ss-item:hover { background:rgba(255,255,255,.06); color:rgba(255,255,255,.85); }
  .ss-item.active { background:rgba(245,158,11,.15); color:#fbbf24; border-left:3px solid #f59e0b; padding-left:9px; }
  .ss-item svg { width:16px; height:16px; stroke-width:1.8; flex-shrink:0; }
  .ss-badge { margin-left:auto; min-width:18px; height:18px; padding:0 5px; border-radius:99px; background:#f59e0b; color:#0a0c1b; font-size:.6rem; font-weight:700; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .ss-footer { padding:12px 10px; border-top:1px solid rgba(255,255,255,.06); font-size:.65rem; color:rgba(255,255,255,.2); text-align:center; }
  .ss-close { display:none; position:absolute; top:14px; right:14px; width:28px; height:28px; border-radius:7px; border:none; background:rgba(255,255,255,.08); color:rgba(255,255,255,.6); cursor:pointer; align-items:center; justify-content:center; }
  .ss-close svg { width:14px; height:14px; stroke-width:2; }
  @media (max-width:768px) {
    .ss { position:fixed; left:-230px; top:0; transition:left .25s ease; }
    .ss.open { left:0; box-shadow:4px 0 20px rgba(0,0,0,.5); }
    .ss-close { display:flex; }
  }
`;

export default function SuperSidebar({ open, onClose }) {
  const location = useLocation();
  return (
    <>
      <style>{css}</style>
      <div className={`ss${open?' open':''}`}>
        <button className="ss-close" onClick={onClose}><XMarkIcon /></button>
        <div className="ss-brand">
          <div className="ss-logo">
            <div className="ss-logo-icon"><ShieldCheckIcon /></div>
            <div>
              <div className="ss-logo-text">School Portal</div>
              <div className="ss-logo-sub">Super Admin</div>
            </div>
          </div>
        </div>
        <nav className="ss-nav">
          {NAV.map(group => (
            <div key={group.label}>
              <div className="ss-group-label">{group.label}</div>
              {group.items.map(item => {
                const active = location.pathname === item.href || location.pathname.startsWith(item.href+'/');
                return (
                  <Link key={item.name} to={item.href}
                    className={`ss-item${active?' active':''}`}
                    onClick={onClose}>
                    <item.icon /><span className="ss-item-text">{item.name}</span>
                    {item.badge && <span className="ss-badge">●</span>}
                  </Link>
                );
              })}
            </div>
          ))}
        </nav>
        <div className="ss-footer">Super Admin Panel · v1.0</div>
      </div>
    </>
  );
}